// For each view you need to create a function to add it to the state provider
function initSecurityStates($stateProvider) {

    $stateProvider.state('home', {
        abstract : true,
        url : "/home",
        templateUrl : "views/common/content.html"
    }).state('home.dashboardCM', {
        url : "/dashboardCM",
        templateUrl : "views/dashboard/dashboardCommercialManager.html",
        controller: "dashboardCommercialManagerCtrl",
        resolve:{
        	dataIni:  function(dashboardService){
        		return dashboardService.getCM().then(function(response){
        			return {status: true, response: response};
        		},function(response){
        			return {status: false, response: response};
        		});
        	}
        },
		data : {
			permissions : {
				only : [ ROLE_TYPE.COMMERCIAL_MANAGER.code ]
			}
		}
	}).state('home.dashboardClient', {
        url : "/dashboardClient",
        templateUrl : "views/dashboard/dashboardClient.html",
        controller: "dashboardClientCtrl",
        resolve:{
        	dataIni:  function(dashboardService){
        		return dashboardService.getClient().then(function(response){
        			return {status: true, response: response};
        		},function(response){
        			return {status: false, response: response};
        		});
        	}
        },
		data : {
			permissions : {
				only : [ ROLE_TYPE.CLIENT.code ]
			}
		}
	}).state('home.administration', {
        data : {
			permissions : {
				only : [ ROLE_TYPE.ADMIN.code ]
			}
        }
    }).state('home.notifications', {
        data : {
			permissions : {
				only : ROLE_TYPE.codesExceptClient()
			}
        }
    }).state('home.dashboard', {
        url : '/home',
        templateUrl : 'views/common/blank.html',
        data : {
            pageTitle : 'Home',
            permissions : {
				only : ROLE_TYPE.codes()
			}
        }
    });
}
